import * as React from 'react';
import { RouteComponentProps, Switch } from 'react-router';

import { PrivateRoute } from 'src/router';

import { CurrencyExchangeListController } from './currencies/exchanges/currency-exchanges.controller';

import { ProductCategoryListController } from './product-categories/list/product-category-list.controller';
import { ProductCategoryFormController } from './product-categories/form/product-category-form.controller';

import { ProductListController } from './products/list/product-list.controller';
import { ProductFormController } from './products/form/product-form.controller';

import { ProductProviderListController } from './product-providers/list/product-provider-list.controller';
import { ProductProviderFormController } from './product-providers/form/product-provider-form.controller';

import { SupplierListController } from './suppliers/list/supplier-list.controller';
import { SupplierFormController } from './suppliers/form/supplier-form.controller';

import { EntityMappingController } from './entity-mappings/entity-mapping.controller';

import { AllotmentListController } from './allotment/list/allotment-list.controller';
import { AllotmentFormController } from './allotment/form/allotment-form.controller';
import { ContractSimulatorController } from './contractSimulator/contract-simulator.controller'
import * as Permissions from "../permissions";

export class ProductsController extends React.Component<RouteComponentProps<any>, any> {
	render() {
		const match = this.props.match;
		return (
			<Switch>
				<PrivateRoute
					path={`${match.url}/currencies/exchanges`}
					component={CurrencyExchangeListController}
					permissions={Permissions.currencyExchangePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/categories/:id`}
					component={ProductCategoryFormController}
					permissions={Permissions.productCategoryWritePermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/categories`}
					component={ProductCategoryListController}
					permissions={Permissions.productCategoryPermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/products/:id/:type?`}
					component={ProductFormController}
					permissions={Permissions.productWritePermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/products`}
					component={ProductListController}
					permissions={Permissions.productPermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/product-providers/:id`}
					component={ProductProviderFormController}
					permissions={Permissions.productProviderWritePermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/product-providers`}
					component={ProductProviderListController}
					permissions={Permissions.productProviderPermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/suppliers/:id`}
					component={SupplierFormController}
					permissions={Permissions.supplierWritePermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/suppliers`}
					component={SupplierListController}
					permissions={Permissions.supplierPermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/entity-mappings`}
					component={EntityMappingController}
					permissions={Permissions.entityMappingPermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/allotment/:id`}
					component={AllotmentFormController}
					permissions={Permissions.allotmentWritePermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/allotment`}
					component={AllotmentListController}
					permissions={Permissions.allotmentPermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/contractSimulator`}
					component={ContractSimulatorController}
					permissions={Permissions.productPermissions}
					{...this.props}
				/>
			</Switch>
		);
	}
}     



// WEBPACK FOOTER //
// ./src/app/products/products.controller.tsx